import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { MENU_ITEM_SLOT, menuActionCircle } from '../styled';

export const StyledGroupRoot = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${MENU_ITEM_SLOT}px;
  height: ${MENU_ITEM_SLOT}px;
  flex-shrink: 0;
`;

export const StyledGroupTrigger = styled.button<{ $expanded: boolean }>`
  ${menuActionCircle}
  padding: 0;
  border: none;
  cursor: pointer;
  background: rgba(48, 70, 89, 0.1);
  color: #304659;
  transition: background 0.2s ease, transform 0.2s ease;

  ${({ $expanded }) =>
    $expanded &&
    css`
      background: rgba(48, 70, 89, 0.16);
    `}

  &:hover {
    background: rgba(48, 70, 89, 0.16);
  }

  &:active {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.color.brightTurquoise};
  }
`;

export const StyledTriggerWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const StyledExpandedPanelAnchor = styled.div`
  position: fixed;
  z-index: 100000001;
  pointer-events: none;
`;

export const StyledExpandedPanel = styled(motion.div)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  padding: 5px 8px;
  background: ${({ theme }) => theme.color.white};
  border-radius: 28px;
  box-shadow: 0 4px 16px rgba(15, 24, 20, 0.14);
  pointer-events: auto;
  transform: translateY(-50%);
`;

export const StyledExpandedItem = styled(motion.div)`
  flex-shrink: 0;

  a {
    margin: 0;
  }
`;
